module.exports = __webpack_public_path__ + "static/media/t1dGwen.acaa50b8.png";